import { Route, Routes } from "react-router-dom";
import { useAnalyticsPageViews } from "../analytics/analytics.hooks";
import { RoutePath } from "../navigation/Routing";
import About from "../pages/About";
import Blog from "../pages/Blog";
import BlogPost from "../pages/BlogPost";
import Connect from "../pages/Connect";
import Disclaimer from "../pages/Disclaimer";
import Experience from "../pages/Experience";
import ExperienceInfo from "../pages/ExperienceInfo";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Process from "../pages/Process";

const Router = () => {
  useAnalyticsPageViews();
  
  const pages = [
    { path: RoutePath.Home, component: <Home /> },
    { path: RoutePath.About, component: <About /> },
    { path: RoutePath.Blog, component: <Blog /> },
    { path: RoutePath.BlogPost, component: <BlogPost /> },
    { path: RoutePath.Connect, component: <Connect /> },
    { path: RoutePath.Disclaimer, component: <Disclaimer /> },
    { path: RoutePath.Experience, component: <Experience /> },
    { path: RoutePath.ExperienceInfo, component: <ExperienceInfo /> },
    { path: RoutePath.PrivacyPolicy, component: <PrivacyPolicy /> },
    { path: RoutePath.Process, component: <Process /> },
    { path: '*', component: <NotFound />}
  ];
  const routes = pages.map(({ path, component }) => (
    <Route path={path} element={component} key={`route-key-for-path-${path}`}></Route>
  ));

  return <Routes>{routes}</Routes>;
};

export default Router;
